module.exports = __webpack_public_path__ + "static/media/afd_1.8adaf295.png";